import L from "leaflet";

/**
 * Pin a goccia per i punti che ereditano la posizione da una SEDE, colorato dal
 * chiamante. Vive qui e non dentro una pagina perché lo usano sia la Mappa
 * multi-livello (dove il colore identifica il modulo) sia la mappa Wink On Cash
 * di Statistiche (dove il colore è quello del servizio nel riepilogo
 * Dispositivi): due copie divergerebbero al primo ritocco, e il trattamento dei
 * punti approssimati qui sotto è esattamente la cosa che non deve divergere.
 *
 * ## I punti approssimati si vedono che lo sono
 *
 * Circa un terzo delle sedi è posizionato al centro del comune e non
 * all'indirizzo: sono indirizzi che nessuna ripulitura è riuscita a risolvere.
 * Un pin così può stare a chilometri dal posto vero, e disegnarlo identico agli
 * altri sarebbe un'affermazione falsa fatta in silenzio. Prende quindi
 * riempimento trasparente, bordo tratteggiato e centro vuoto: si legge come
 * "qui intorno" invece che "qui", che è esattamente quanto ne sappiamo.
 *
 * `dettaglio` colora il pallino centrale, bianco se non specificato — cioè il
 * pin che la Mappa multi-livello ha sempre disegnato, invariato. Serve alla
 * mappa Wink On Cash, che usa i due colori del marchio insieme (corpo verde,
 * pallino arancio) per rendersi riconoscibile a colpo d'occhio. Non si applica
 * ai pin approssimati: lì il centro è vuoto apposta, ed è quel vuoto a dire
 * "posizione incerta".
 */
export function buildPuntoIcon(colore: string, approssimato: boolean, dettaglio = "white"): L.DivIcon {
  const corpo = approssimato
    ? `<path d="M13 0C5.8 0 0 5.8 0 13c0 9.5 13 21 13 21s13-11.5 13-21C26 5.8 20.2 0 13 0z"
         fill="${colore}" fill-opacity="0.3" stroke="${colore}" stroke-width="2" stroke-dasharray="3 2.5"/>
       <circle cx="13" cy="13" r="4.5" fill="none" stroke="${colore}" stroke-width="1.8"/>`
    : `<path d="M13 0C5.8 0 0 5.8 0 13c0 9.5 13 21 13 21s13-11.5 13-21C26 5.8 20.2 0 13 0z"
         fill="${colore}" stroke="white" stroke-width="1.5"/>
       <circle cx="13" cy="13" r="5" fill="${dettaglio}"/>`;

  return L.divIcon({
    className: "",
    html: `<svg width="26" height="34" viewBox="0 0 26 34" xmlns="http://www.w3.org/2000/svg">${corpo}</svg>`,
    iconSize: [26, 34],
    iconAnchor: [13, 34],
    popupAnchor: [0, -30],
  });
}
